import { render, staticRenderFns } from "./SoftwareProduct.vue?vue&type=template&id=4e6555c2&scoped=true"
import script from "./SoftwareProduct.vue?vue&type=script&lang=js"
export * from "./SoftwareProduct.vue?vue&type=script&lang=js"
import style0 from "./SoftwareProduct.vue?vue&type=style&index=0&id=4e6555c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6555c2",
  null
  
)

export default component.exports